import styled from 'styled-components';
import { getFixedSpace, mq } from '../../../stylesheets/tools';

const StyledBasicTeaserShaped = styled.div`
  .teaser__container {
    max-width: 100%;
    width: 100%;
    display: block;
    position: relative;

    .teaser__image {
      aspect-ratio: 4/3;
      margin-bottom: 30px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .teaser__link {
      margin-top: 20px;

      svg {
        position: relative;
        z-index: 5;
      }
    }
    .teaser__link,
    .teaser__content {
      padding-right: 40px;
      padding-left: 20px;

      ${mq('l')} {
        padding-right: 60px;
      }
    }
    .teaser__content-container {
      margin-left: -1px;
      padding-right: 10px;

      &.with-mask {
        margin-top: -80px;

        ${mq('l')} {
          margin-top: -120px;
        }

        .teaser__mask {
          position: absolute;
          background-color: #fff;
          clip-path: polygon(0 0, 88% 24%, 100% 100%, 0% 100%);
          width: 100%;
          height: 85px;

          ${mq('l')} {
            clip-path: polygon(86% 15%, 100% 60%, 95% 100%, 0 100%, 0 0);
            height: 125px;
          }
        }

        .teaser__content {
          padding-top: 50px;
        }
      }

      ${mq('l')} {
        padding-right: 40px;
      }

      .teaser__content-inner {
        position: relative;

        .teaser__content {
          position: relative;
          z-index: 5;

          .teaser__headlines {
            margin-bottom: ${getFixedSpace('xs')};

            h4 {
              margin-bottom: ${getFixedSpace('xxxs')};
            }
          }
          p {
            font-size: 14px;
            line-height: 1.75;
          }
        }
      }
    }
  }
`;

export default StyledBasicTeaserShaped;
